import React, { useContext, useEffect, useState, useMemo } from 'react';
import { Form, Row, Col, OverlayTrigger, Tooltip, Modal } from 'react-bootstrap';
import { Skeleton, Menu, MenuItem } from '@mui/material'
import { ApiContext } from '../../context/ApiContext';
import { IoIosWarning } from 'react-icons/io';
import ModalObterCapacidade from '../modal/ModalObterCapacidade';
import ModalVerSwot from '../modal/ModalVerSwot';

export default function MapaCalor() {
    const { ObterMapaCalor, MapaCalor, ListaAreaUsuarioMapaCalor, AreaUsuarioMapaCalor, Error, loading, setCapacidadeAtualKey, RetornaMapaCalor, Visao } = useContext(ApiContext);
    const [areaKey, setAreaKey] = useState("")
    const [visao, setVisao] = useState("")
    const [modalObterCapacidade, setModalObterCapacidade] = useState(false);
    const [modalVerSwot, setModalVerSwot] = useState(false);
    const [swotTIModal, setSwotTIModal] = useState(false);
    const [contextMenu, setContextMenu] = useState(null);
    const [capacidadeSelecionada, setCapacidadeSelecionada] = useState(null);

    useEffect(() => {
        if (areaKey, visao) {
            ObterMapaCalor(areaKey, visao);
        }
    }, [areaKey, visao]);

    useEffect(() => {
        ListaAreaUsuarioMapaCalor();
        RetornaMapaCalor();
    }, []);

   const obterCapacidade = (capacidade) => {
    if (!capacidade) return;

    setModalObterCapacidade(true);
    setCapacidadeAtualKey(capacidade.capacidadeNegocioDemanda.key);
};

const abrirMenuContexto = (event, capacidade) => {
    event.preventDefault();

    setCapacidadeSelecionada(capacidade);

    setContextMenu({
        mouseX: event.clientX + 2,
        mouseY: event.clientY - 6,
    });
};

const fecharMenuContexto = () => {
    setContextMenu(null);
};

const abrirSwot = () => {
    setSwotTIModal(false);
    setModalVerSwot(true);
    fecharMenuContexto();
};

const abrirSwotTI = () => {
    setSwotTIModal(true);
    setModalVerSwot(true);
    fecharMenuContexto();
};

    const dominiosOrdenados = useMemo(() => {
        if (!MapaCalor?.dominios) return [];
        return MapaCalor.dominios.map((dom) => {
            const copiaPai = (dom?.dominioPai || []).slice();
            copiaPai.sort((a, b) => {
                const nivelA = a?.capacidadeNegocioDemanda?.nivel;
                const nivelB = b?.capacidadeNegocioDemanda?.nivel;

                // ambos têm nível -> compara numericamente
                if (nivelA != null && nivelB != null) {
                    return Number(nivelA) - Number(nivelB);
                }
                // só A tem nível -> A vem antes
                if (nivelA != null && nivelB == null) return -1;
                // só B tem nível -> B vem antes (A depois)
                if (nivelA == null && nivelB != null) return 1;
                // nenhum tem nível -> ordenar por título
                const tituloA = a?.capacidadeNegocioDemanda?.titulo || '';
                const tituloB = b?.capacidadeNegocioDemanda?.titulo || '';
                return tituloA.localeCompare(tituloB);
            });
            return { ...dom, dominioPai: copiaPai };
        });
    }, [MapaCalor]);

    const totalCols = useMemo(() => {
        return dominiosOrdenados.reduce(
            (acc, d) => acc + (d?.dominioPai?.length || 0),
            0
        );
    }, [dominiosOrdenados]);

    return (
        <>
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            {modalObterCapacidade &&
                <ModalObterCapacidade setModal={setModalObterCapacidade} />
            }
            {modalVerSwot &&
                <ModalVerSwot
                    setModal={setModalVerSwot}
                    capacidade={capacidadeSelecionada}
                    areaKey={areaKey}
                    swotTI={swotTIModal}
                    onSaved={() => ObterMapaCalor(areaKey, visao)}
                />
            }
            <h2 className="h2-bsc" style={{ paddingLeft: '20px' }}>
                <span style={{ fontWeight: '500' }}>Mapa de Calor</span>
            </h2>

            <Row style={{ padding: '10px 20px', alignItems: 'flex-end' }}>
                <Col xs={5}>
                    <Form.Label>Área</Form.Label>
                    <Form.Select onChange={(e) => setAreaKey(e.target.value)} name="areaKey">
                        <option value="0">Selecione</option>
                        {AreaUsuarioMapaCalor &&
                            AreaUsuarioMapaCalor?.map((item) => {
                                return (
                                    <option key={item.id} value={item.key}>
                                        {item.descricao}
                                    </option>
                                )
                            })}
                    </Form.Select>
                </Col>
                <Col xs={4}>
                    <Form.Label>Visão</Form.Label>
                    <Form.Select onChange={(e) => setVisao(e.target.value)} name="visao">
                        <option value="0">Selecione</option>
                        {Visao &&
                            Visao?.map((item) => {
                                return (
                                    <option key={item} value={item}>
                                        {item}
                                    </option>
                                )
                            })}
                    </Form.Select>
                </Col>
                {visao === "SWOT" &&
                    <>
                        <Col xs={1}>
                            <Form.Label>Legenda</Form.Label>
                            <div className="span-bsc" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <div style={{ width: 24, height: 18, backgroundColor: '#90caf9' }} />
                                Força
                            </div>
                            <div className="span-bsc" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <div style={{ width: 24, height: 18, backgroundColor: '#ef9a9a' }} />
                                Fraqueza
                            </div>
                        </Col>
                        <Col xs={2}>
                            <div className="span-bsc" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <div style={{ width: 24, height: 18, backgroundColor: '#ffcc80' }} />
                                Ameaça
                            </div>
                            <div className="span-bsc" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <div style={{ width: 24, height: 18, backgroundColor: '#a5d5a7' }} />
                                Oportunidade
                            </div>
                        </Col>
                    </>
                }
            </Row>
            {loading ? <Skeleton variant="rounded" width="100%" height={450} sx={{ marginBottom: 2 }} /> :
                <>
                    {(areaKey && visao) ? (
                        dominiosOrdenados?.length > 0 &&
                            dominiosOrdenados.some(dom => dom?.dominioPai?.length > 0) ? (
                            <div className="modal-content" style={{ padding: 12 }}>
                                {/* Cabeçalho pai */}
                                <div
                                    style={{
                                        display: 'grid',
                                        gridTemplateColumns: `150px repeat(${totalCols || 0}, 1fr)`,
                                        gap: 10,
                                        marginBottom: 4,
                                    }}
                                >
                                    <div></div> {/* espaço do label de linha */}

                                    {dominiosOrdenados.map((dom, i) => {
                                        const colSpan = dom?.dominioPai?.length || 1;
                                        return (
                                            <div
                                                key={dom?.key ?? i}
                                                style={{
                                                    textAlign: 'center',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontWeight: '700',
                                                    fontSize: 13,
                                                    gridColumn: `span ${colSpan}`,
                                                    backgroundColor: dom?.corHexadecimal || '#eee',
                                                    borderRadius: 4,
                                                    padding: '4px 0',
                                                }}
                                            >
                                                {dom?.descricao || `Domínio ${i + 1}`}
                                            </div>
                                        );
                                    })}
                                </div>

                                {/* Cabeçalho filho */}
                                <div
                                    style={{
                                        display: 'grid',
                                        gridTemplateColumns: `150px repeat(${totalCols || 0}, 1fr)`,
                                        gap: 10,
                                        marginBottom: 8,
                                    }}
                                >
                                    <div></div>

                                    {dominiosOrdenados.flatMap((dom) =>
                                        dom?.dominioPai?.map((filho, idx) => (
                                            <div
                                                key={`${dom?.descricao}-${filho?.key ?? idx}`}
                                                style={{
                                                    textAlign: 'center',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontWeight: '700',
                                                    fontSize: 13,
                                                    backgroundColor: filho?.capacidadeNegocioDemanda?.corHexadecimal,
                                                    borderRadius: 4,
                                                    padding: '4px 0',
                                                }}
                                            >
                                                {`${filho?.capacidadeNegocioDemanda?.nivel ? `${filho.capacidadeNegocioDemanda.nivel} - ` : ''}${filho?.capacidadeNegocioDemanda?.titulo || `Subdomínio ${idx + 1}`}`}
                                            </div>
                                        ))
                                    )}
                                </div>

                                {/* GRID 3 linhas (Estratégico / Tático / Operacional) */}
                                <div
                                    style={{
                                        display: 'grid',
                                        gridTemplateColumns: `150px repeat(${totalCols || 0}, 1fr)`,
                                        gap: 10,
                                        alignItems: 'start',
                                    }}
                                >
                                    {[
                                        { key: 'tipoEstrategico', label: 'Estratégico' },
                                        { key: 'tipoTatico', label: 'Tático' },
                                        { key: 'tipoOperacional', label: 'Operacional' },
                                    ].map((tipo) => (
                                        <React.Fragment key={tipo.key}>
                                            {/* Label da linha */}
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontWeight: '700',
                                                    backgroundColor:
                                                        tipo.key === 'tipoEstrategico'
                                                            ? '#ffd966'
                                                            : tipo.key === 'tipoTatico'
                                                                ? '#9bc2e6'
                                                                : '#8497b0',
                                                    borderRadius: 4,
                                                    height: '100%',
                                                }}
                                            >
                                                {tipo.label}
                                            </div>

                                            {/* Colunas dinâmicas */}
                                            {dominiosOrdenados.flatMap((dominio) =>
                                                dominio?.dominioPai?.map((filho, idx) => {
                                                    const elementos =
                                                        filho?.[tipo.key]?.elemento || [];

                                                    return (
                                                        <div
                                                            key={`${dominio.descricao}-${tipo.key}-${filho?.key ?? idx}`}
                                                            style={{
                                                                minHeight: 140,
                                                                height: '100%',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                gap: 6,
                                                                alignItems: 'stretch',
                                                                justifyContent:
                                                                    elementos.length === 0
                                                                        ? 'center'
                                                                        : 'flex-start',
                                                            }}
                                                        >
                                                            {elementos.length === 0 ? (
                                                                <div
                                                                    style={{
                                                                        height: 100,
                                                                        borderRadius: 6,
                                                                        backgroundColor: 'transparent',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        color: '#999',
                                                                    }}
                                                                >
                                                                    {/* célula vazia */}
                                                                </div>
                                                            ) : (
                                                                elementos
                                                                    ?.slice()
                                                                    ?.sort((a, b) => {
                                                                        const nivelA = a?.capacidadeNegocioDemanda?.nivel ?? 0;
                                                                        const nivelB = b?.capacidadeNegocioDemanda?.nivel ?? 0;
                                                                        return nivelA - nivelB;
                                                                    })
                                                                    ?.map((el, idxEl) => (
                                                                        <button
                                                                            key={idxEl}
                                                                            style={{
                                                                                position: 'relative',
                                                                                borderRadius: 6,
                                                                                backgroundColor:
                                                                                    el?.cor || '#f0f0f0',
                                                                                flex: 1,
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                textAlign: 'center',
                                                                                color: '#000',
                                                                                fontWeight: 700,
                                                                                fontSize: 12,
                                                                                minHeight: '75px',
                                                                                border: 'none',
                                                                            }}
                                                                            onClick={() => obterCapacidade(el)}
onContextMenu={(e) => abrirMenuContexto(e, el)}
                                                                        >
                                                                            <div>
                                                                                {`${el?.capacidadeNegocioDemanda?.nivel ? `${el.capacidadeNegocioDemanda.nivel} - ` : ''}${el?.capacidadeNegocioDemanda?.titulo || ''}`}
                                                                            </div>

                                                                            {/* badges R/C/T */}
                                                                            <div
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    bottom: 0,
                                                                                    left: 0,
                                                                                    display: 'flex',
                                                                                }}
                                                                            >
                                                                                {el?.rodar && (
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={<Tooltip id="tooltip-rodar">Rodar</Tooltip>}
                                                                                    >
                                                                                        <span
                                                                                            style={{
                                                                                                padding: '2px 4px',
                                                                                                backgroundColor: '#f4b084',
                                                                                                fontSize: 10,
                                                                                                cursor: 'default',
                                                                                            }}
                                                                                        >
                                                                                            R
                                                                                        </span>
                                                                                    </OverlayTrigger>
                                                                                )}

                                                                                {el?.crescer && (
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={<Tooltip id="tooltip-crescer">Crescer</Tooltip>}
                                                                                    >
                                                                                        <span
                                                                                            style={{
                                                                                                padding: '2px 4px',
                                                                                                backgroundColor: '#92d050',
                                                                                                fontSize: 10,
                                                                                                cursor: 'default',
                                                                                            }}
                                                                                        >
                                                                                            C
                                                                                        </span>
                                                                                    </OverlayTrigger>
                                                                                )}

                                                                                {el?.transformar && (
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={<Tooltip id="tooltip-transformar">Transformar</Tooltip>}
                                                                                    >
                                                                                        <span
                                                                                            style={{
                                                                                                padding: '2px 4px',
                                                                                                backgroundColor: '#00b0f0',
                                                                                                fontSize: 10,
                                                                                                cursor: 'default',
                                                                                            }}
                                                                                        >
                                                                                            T
                                                                                        </span>
                                                                                    </OverlayTrigger>
                                                                                )}
                                                                            </div>

                                                                            {/* quantidade */}
                                                                            <div
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    bottom: 6,
                                                                                    right: 6,
                                                                                    fontSize: 12,
                                                                                    fontWeight: 600,
                                                                                }}
                                                                            >
                                                                                {el?.quantidade ?? ''}
                                                                            </div>
                                                                        </button>
                                                                    ))
                                                            )}
                                                        </div>
                                                    );
                                                })
                                            )}
                                        </React.Fragment>
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <div
                                style={{
                                    padding: 40,
                                    textAlign: 'center',
                                    color: '#777',
                                    fontWeight: 600,
                                    fontSize: 15,
                                }}
                            >
                                Nenhum dado encontrado.
                            </div>
                        )
                    ) : (
                        <div className='span-bsc' style={{ padding: 20 }}>
                            Selecione uma área e uma visão para visualizar o mapa de calor.
                        </div>
                    )}
                </>
            }
<Menu
    open={contextMenu !== null}
    onClose={fecharMenuContexto}
    anchorReference="anchorPosition"
    anchorPosition={
        contextMenu !== null
            ? {
                top: contextMenu.mouseY,
                left: contextMenu.mouseX,
            }
            : undefined
    }
>
    <MenuItem
        onClick={() => {
            obterCapacidade(capacidadeSelecionada);
            fecharMenuContexto();
        }}
    >
        Ver Capacidade de Negócio
    </MenuItem>

    <MenuItem onClick={abrirSwot}>
        Ver SWOT
    </MenuItem>

    <MenuItem onClick={abrirSwotTI}>
        Ver SWOT de TI
    </MenuItem>
</Menu>

        </>
    );
}
